<div class="create-category">
    <div *ngIf="showSpinner" class="progress-spinner">
        <mat-spinner></mat-spinner>
    </div>
    <mat-card-title class="mat-display-1">
        <span>Kategorie erstellen</span>
    </mat-card-title>
    <div class="form">
        <mat-card>
            <mat-card-content>
                <div class="new-form">
                    <form *ngIf="courseCategoryForm" [formGroup]="courseCategoryForm" (ngSubmit)="submitForm()">
                        <div class="mb-2">  
                            <div class="title1">
                                <span class="projName">Name</span>
                                <div class="subtitle1">
                                    <input class="inputTitle" formControlName="name" label="Ihr Name hier"
                                        placeholder="Ihr Name hier">
                                </div>
                            </div>
                            <span class="note">Mindestens 4 Zeichen</span>
                        </div>
                        <div class="mb-2">  
                            <div class="title1">
                                <span class="projName">Description</span>
                                <div class="subtitle1">
                                    <textarea class="inputTitle" formControlName="description" label="Ihr Name hier"
                                        placeholder="Ihr Name hier"  cols="30" rows="10"></textarea>
                                </div>
                            </div>
                            <span class="note">Mindestens 10 Zeichen</span>
                        </div>
                        
                        <mat-card-actions>
                            <button mat-raised-button color="primary" [disabled]="courseCategoryForm.invalid">
                                Speichern
                            </button>
                            <button
                            mat-raised-button
                            color="primary"
                            (click)="cancelEdit()">
                            Cancel
                        </button>
                        </mat-card-actions>
                    </form>
                </div>

            </mat-card-content>
        </mat-card>
    </div>
</div>